import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import * as _ from 'lodash';
import { RegexEnum } from 'src/app/core/enum/regex.enum';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { CarrierService } from 'src/app/services/carrier/carrier.service';
import { BusinessUnitEnum } from 'src/app/shared/enum/business-unit.enum';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';

@Component({
  selector: 'app-update',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.scss']
})
export class UpdateCarrierComponent implements OnInit {


  public carrierUserID: string;
  private sub: any;
  public userType: string = 'user';
  public viewOnly: boolean = false;
  public loading: boolean = false;
  public carrierUpdate: {} = { organizationCode: '' };
  public privileges: {} = {
    HC_CARRIER_CREATE_USER: false, HC_CARRIER_DELETE_USER: false,
    HC_CARRIER_UPDATE_USER: false, HC_CARRIER_VIEW_USER: false
  };
  public userManagement: boolean = false;
  public originLimitations: boolean = false;
  public destinationLimitations: boolean = false;
  public isAdhoc: boolean = false;
  public currentUserRole: string = '';
  public phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  public roleOptions: object[] = [];
  public businessUnitEnum = BusinessUnitEnum;
  public keepOriginalOrder = (a, b) => a.key;
  public carrierId: string;
  public userLocations: string[] = [];
  public affiliatedCarrier: string;
  public invalidUserVisibility: boolean = false;

  public carrierAdminRole: {} = {
    value: 'HC_CARRIER_ADMIN',
    name: 'Admin - I',
    description: 'Admin - I role grants a user permission to add, update, remove, and reset passwords. Users who have admin role automatically have accounting and invoicing roles.\nNote: This Admin - Type One role is intended to be assigned for carriers who are not freight brokers.'
  };
  public carrierAccountingRole: {} = {
    value: 'HC_CARRIER_ACCOUNTING',
    name: 'Accounting',
    description: 'Carrier Accounting Role that allows only invoicing-related actions, such as submitting invoice numbers and uploading paperwork.'
  };

  public carrierDispatcherRole: {} = {
    value: 'HC_CARRIER_DISPATCHER',
    name: 'Dispatcher',
    description: 'Carrier Dispatcher Role with load board access that allows the user the ability to bid on loads, accept/reject tenders, assign drivers and track a load through the lifecycle.'
  };

  public carrierBrokerAdminRole: {} = {
    value: 'HC_CARRIER_BROKER_ADMIN',
    name: 'Admin - II',
    description: 'Admin - II role gives a user permission to add, update, remove, and reset passwords. Users who have admin role automatically have broker role.\nNote: This Admin - II role is intended to be assigned for carriers who are also freight brokers.'
  };

  public carrierBrokerUserRole: {} = {
    value: 'HC_CARRIER_BROKER_USER',
    name: 'Broker',
    description: 'Broker role provide access to my shipments through which user can accept/reject tenders, assign drivers and track a load through lifecyle, and invoicing related actions such as submitting invoice number and updating paperwork.\nNote: Broker role does not provide access to the load board.'
  };

  carrierUser: any;
  public regexEnum = RegexEnum;

  constructor(
    public currentUserService: CurrentUserService,
    public carrierService: CarrierService,
    private route: ActivatedRoute,
    private router: Router,
    private flashMessageService: FlashMessageService,
    private cdRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.loading = true;
    this.carrierService.updatedCarrierUser.organization = {};
    this.carrierService.initialCarrierUnit = {};
    this.carrierService.carrierUnit = {};
    this.carrierService.nameIsInvalid = false;
    if (!this.currentUserService.user) {
      this.router.navigate(['../../users'], { relativeTo: this.route });
      return false;
    }

    if (this.currentUserService.isInternal) {
      this.loading = true;
    }

    if (this.currentUserService.entitlements['HC_CARRIER_VIEW_USER'] && !this.currentUserService.entitlements['HC_CARRIER_UPDATE_USER']) {
      this.viewOnly = true;
    }

    this.assignRoleValues();
    this.sub = this.route.queryParams.subscribe(params => {
      if (params['affiliatedCarrier']) {
        this.affiliatedCarrier = params['affiliatedCarrier'];
      }
      if (params['facCompanyID'] || params['userType'] === 'HC_CR_FACTORING_ADMIN') {
        this.carrierService.isFactoringCompany = true;
        this.carrierService.updatedCarrierUser.organization.organizationCode = params.facCompanyID;
      } else {
        this.carrierService.isFactoringCompany = false;
      }
      this.carrierUserID = params['ID'];

      if (params['carrierID']) {
        this.carrierService.updatedCarrierUser.organization.organizationCode = this.affiliatedCarrier || params['carrierID'];
        this.carrierUpdate['organizationCode'] = this.affiliatedCarrier || params['carrierID'];
      } else {
        this.carrierService.updatedCarrierUser.organization.organizationCode = params['facCompanyID'];
        this.carrierUpdate['organizationCode'] = params['facCompanyID'];
      }

      if (this.currentUserService.user.role.type.toLowerCase() === 'carrier') {
        this.carrierService.updatedCarrierUser.organization.organizationCode = this.affiliatedCarrier || this.currentUserService.user.organizationCode;
        this.carrierService.updatedCarrierUser.organizationName = this.currentUserService.user.organizationName;
      }
      if (this.carrierService.all.length) {
        this.carrierUpdate = this.carrierService.getCarrier(this.affiliatedCarrier || params['carrierID']);
      }

      if (params['ID'] && !params['edit']) {
        this.carrierService.getCarrierAffiliatedUser(this.carrierUserID, this.affiliatedCarrier).then((resp) => {
          this.carrierUser = _.clone(resp);
          this.carrierService.updatedCarrierUser.organizationName = resp['organizationName'];
          this.carrierService.updatedCarrierUser.name = resp['firstname'] + " " + resp['lastname'];
          this.carrierService.updatedCarrierUser.email = resp['email'];
          this.carrierService.updatedCarrierUser.phone = resp['phone'];
          this.carrierService.updatedCarrierUser.mobile_phone = resp['alternatePhone'];
          const roleCode = (_.find(resp['applications'], f => f.organizationCode === resp['organizationCode']) || resp['applications'][0])['roleCode'];
          this.carrierService.updatedCarrierUser.roleCode = roleCode;
          this.carrierService.updatedCarrierUser.registeredDate = resp['registeredDate'];
          this.carrierId = _.get(resp, 'organizationCode');
          this.userLocations = _.get(resp, 'extended.locations');
          _.set(this.carrierUser, 'role.code', roleCode);
          this.setupPrivileges();
          resp['entitlements'].forEach((p) => {
            this.matchPrivileges(p.code);
          })
          this.loading = false;
        })
          .catch((error) => {
            this.loading = false;
            if (error.status = 401) {
              this.flashMessageService.updateMessage('You are not Authorized to access this User');
            }
            this.router.navigate(['../../users/all'], { relativeTo: this.route });
          })
        if (this.checkIfHubAdminAndForCarrier()) {
          this.carrierService.updateCarrierUnit(this.carrierService.updatedCarrierUser.organization.organizationCode);
        }
      } else if (params['edit']) {
        this.carrierService.updatedCarrierUser.name = params['name'];
        this.carrierService.updatedCarrierUser.email = params['email'];
        this.carrierService.updatedCarrierUser.phone = params['phone'];
        this.carrierService.updatedCarrierUser.organization.organizationCode = this.affiliatedCarrier || params['carrierID'];
        this.carrierService.updatedCarrierUser.organization.organizationName = params['organization'];
        this.carrierService.updatedCarrierUser.registeredDate = params['registeredDate'];
        this.carrierId = this.carrierService.updatedCarrierUser.organization.organizationCode;
        this.userLocations = params['vendorLocations'];
        if (params['unit'] && params['mode']) {
          this.setUnitAndMode(params['mode'], params['unit'])
        }
        if (params['mobile'] == "null" || params['mobile'] == 'undefined') {
          this.carrierService.updatedCarrierUser.mobile_phone = null;
        } else {
          this.carrierService.updatedCarrierUser.mobile_phone = params['mobile'];
        }
        this.carrierService.updatedCarrierUser.roleCode = params['userType'];
        params['entitlements'].forEach((p) => {
          this.matchPrivileges(p);
        })
        this.loading = false;
      } else {
        this.router.navigate(['../../'], { relativeTo: this.route });
      }
    });
  }

  public setUnitAndMode(mode, unit) {
    this.carrierService.carrierUnit.transportMode = mode;
    if (typeof unit === 'object') {
      this.carrierService.carrierUnit.businessUnit = unit;
    } else {
      this.carrierService.carrierUnit.businessUnit = [unit];
    }
  }

  public checkIfHubAdminAndForCarrier() {
    return this.currentUserRole === 'hubAdmin' && !this.carrierService.isFactoringCompany;
  }

  public assignRoleValues() {
    if (this.currentUserService.user.role.code === "HC_CARRIER_ADMIN") {
      this.currentUserRole = 'carrierAdmin';
      this.roleOptions = [this.carrierAdminRole, this.carrierAccountingRole, this.carrierDispatcherRole, this.carrierBrokerAdminRole, this.carrierBrokerUserRole];
    } else if (this.currentUserService.user.role.code === 'HC_CARRIER_BROKER_ADMIN') {
      this.currentUserRole = 'carrierBrokerAdmin';
      this.roleOptions = [this.carrierBrokerAdminRole, this.carrierBrokerUserRole];
    } else if (this.currentUserService.isInternal) {
      this.currentUserRole = 'hubAdmin';
      this.roleOptions = [this.carrierAdminRole, this.carrierAccountingRole, this.carrierDispatcherRole, this.carrierBrokerAdminRole, this.carrierBrokerUserRole];
    }
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  public matchPrivileges(privilege) {
    this.privileges[privilege] = true;
    if (privilege == "HC_CR_CREATE_USER" || privilege == "HC_CR_DELETE_USER" ||
      privilege == "HC_CR_UPDATE_USER" || privilege == "HC_CR_VIEW_USER") {
      this.userManagement = true;
    }
  }

  public setupPrivileges() {
    this.resetPrivileges();
    var allowed = [];

    // CARRIER ADMIN
    if (this.carrierService.updatedCarrierUser.roleCode == "HC_CARRIER_ADMIN" || this.carrierService.updatedCarrierUser.roleCode === 'HC_CARRIER_BROKER_ADMIN') {
      allowed = [];
      this.userManagement = true;
    }

    // CARRIER USER
    else if (this.carrierService.updatedCarrierUser.roleCode == "HC_CARRIER_ACCOUNTING") {
      allowed = [];
      this.userManagement = false;
    }

    else if (this.carrierService.updatedCarrierUser.roleCode == "HC_CARRIER_DISPATCHER") {
      allowed = [];
      this.userManagement = false;
    }

    else if (this.carrierService.updatedCarrierUser.roleCode === 'HC_CARRIER_BROKER_USER') {
      allowed = [];
      this.userManagement = false;
    }

    this.allowPrivileges(allowed);
  }

  resetPrivileges() { // sets all the user privileges to false/defaults
    for (var key in this.privileges) {
      this.privileges[key] = false;
    }
  }

  allowPrivileges(allowed) { // adds the set privileges for roles
    allowed.forEach(element => {
      this.privileges[element] = true;
    });
    if (this.carrierService.updatedCarrierUser.roleCode.includes('CARRIER')) {
      this.toggleCarrierManagementChoices();
    }
    else {
      this.toggleCarrierManagementChoices();
    }
  }

  public toggleCarrierManagementChoices() {
    if (this.userManagement == true) {
      this.privileges['HC_CR_CREATE_USER'] = true;
      this.privileges['HC_CR_DELETE_USER'] = true;
      this.privileges['HC_CR_UPDATE_USER'] = true;
      this.privileges['HC_CR_VIEW_USER'] = true;
    } else {
      this.privileges['HC_CR_CREATE_USER'] = false;
      this.privileges['HC_CR_DELETE_USER'] = false;
      this.privileges['HC_CR_UPDATE_USER'] = false;
      this.privileges['HC_CR_VIEW_USER'] = false;
    }
  }

  onSubmit() {
    const selectedPrivileges = [];
    const myObj = this.privileges;
    Object.keys(myObj).forEach(function (privilege) {
      if (myObj[privilege] == true) {
        selectedPrivileges.push(privilege);
      }
    });
    this.carrierService.updatedCarrierUser.entitlements = selectedPrivileges;
    if (this.checkIfHubAdminAndForCarrier()) {
      this.carrierService.carrierUnit.transportMode = !this.carrierService.carrierUnit.businessUnit.includes('LGS') ? 'TL' : this.carrierService.carrierUnit.transportMode;
    }
    let queryParms = { ID: this.carrierUserID };
    if (this.affiliatedCarrier) {
      queryParms['affiliatedCarrier'] = this.carrierService.updatedCarrierUser.organization.organizationCode;
    }
    if (this.userLocations && this.userLocations.length && this.showUserVisibility()) {
      _.set(this.carrierService.updatedCarrierUser, "extended.locations", this.userLocations);
    } else {
      _.unset(this.carrierService.updatedCarrierUser, "extended.locations");
    }
    this.router.navigate(['../confirm-update'], { 'relativeTo': this.route, 'queryParams': queryParms });
  }

  showUserVisibility() {
    if (this.checkIfHubAdminAndForCarrier()) {
      return this.carrierService.carrierUnit.businessUnit && this.carrierService.carrierUnit.businessUnit.includes('IML') && this.carrierId;
    } else if (!this.carrierService.isFactoringCompany) {
      return this.carrierId && (this.userLocations || _.get(this.carrierService.updatedCarrierUser, "extended.locations"));
    }
  }

  onLocation($event){
    this.invalidUserVisibility = _.isEmpty($event);
    this.userLocations = $event;
  }

  isInvalidUserVisibility() {
    if (!this.carrierService.carrierUnit.businessUnit || this.carrierService.carrierUnit.businessUnit.includes('IML')) {
      return this.invalidUserVisibility;
    }
    return false;
  }
}
